module.exports = __webpack_public_path__ + "static/media/valor3_1.50a5d68f.jpg";